/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AnswerDto from './AnswerDto';

/**
 * The PaginatedAnswersDto model module.
 * @module model/PaginatedAnswersDto
 * @version v0
 */
class PaginatedAnswersDto {
    /**
     * Constructs a new <code>PaginatedAnswersDto</code>.
     * @alias module:model/PaginatedAnswersDto
     */
    constructor() { 
        
        PaginatedAnswersDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedAnswersDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedAnswersDto} obj Optional instance to populate.
     * @return {module:model/PaginatedAnswersDto} The populated <code>PaginatedAnswersDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedAnswersDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [AnswerDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedAnswersDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedAnswersDto</code>.
     */
    static validateJSON(data) {
        if (data['answers']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['answers'])) {
                throw new Error("Expected the field `answers` to be an array in the JSON data but got " + data['answers']);
            }
            // validate the optional field `answers` (array)
            for (const item of data['answers']) {
                AnswerDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedAnswersDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedAnswersDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedAnswersDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedAnswersDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/AnswerDto>} answers
 */
PaginatedAnswersDto.prototype['answers'] = undefined;






export default PaginatedAnswersDto;

